/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CouponSummaryResponse } from '../../models/coupon-summary-response';

export interface GetCouponSummary$Params {
  'Active-Tenant-Identifier': string;
  couponId: string;
}

export function getCouponSummary(http: HttpClient, rootUrl: string, params: GetCouponSummary$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponSummaryResponse>> {
  const rb = new RequestBuilder(rootUrl, getCouponSummary.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('couponId', params.couponId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CouponSummaryResponse>;
    })
  );
}

getCouponSummary.PATH = '/redemptions/coupon/{couponId}/summary';
